import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Color from "../../theme/color";
import moment from "moment";
import ValidationError from "../validation-error-label";
import NumberFormat from "../number-format";
import { Typography } from "@mui/material";
import {
  convertLocalDateToUTCIgnoringTimezone,
  findDateDiff,
} from "../date-time-validation";

export const PriceTable = ({ values, newData, error }: PriceTableProps) => {
  const [, setValidationError] = useState<string | null>(null);

  const [ticketQuantities, setTicketQuantities] = useState(
    Array(values.length).fill(0)
  );
  useEffect(() => {
    setTicketQuantities(Array(values?.length).fill(0));
  }, [values]);

  useEffect(() => {
    handleBuyTicket();
  }, [ticketQuantities]);

  const handleIncrementQuantity = (index: any) => {
    const newQuantities = [...ticketQuantities];
    newQuantities[index] += 1;
    setTicketQuantities(newQuantities);
  };

  const handleDecrementQuantity = (index: any) => {
    if (ticketQuantities[index] > 0) {
      const newQuantities = [...ticketQuantities];
      newQuantities[index] -= 1;
      setTicketQuantities(newQuantities);
    }
  };

  const totalTicketPrices = ticketQuantities.reduce(
    (total, quantity, index) => total + quantity * values[index]?.price,
    0
  );

  const handleBuyTicket = () => {
    let temp = values.map((x: any, index: any) => {
      if (ticketQuantities[index] !== 0) {
        let amount = x.price * ticketQuantities[index];
        return { ...x, qty: ticketQuantities[index], amount: amount };
      }
      return null;
    });

    let final = temp.filter(function (element: any) {
      return element !== undefined;
    });

    let data = {
      final,
      totalTicketPrices,
      ticketQuantities,
    };

    setValidationError(null);
    if (newData) {
      newData(data);
    }
  };

  return (
    <Grid item xs={12} sm={12} md={12}>
      <Card>
        <CardContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontSize: "18px", color: Color.color22 }}>
                    Ticket Type
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "18px",
                      color: Color.color22,
                      textAlign: "center",
                    }}
                  >
                    Quantity
                  </TableCell>
                  <TableCell style={{ fontSize: "18px", color: Color.color22 }}>
                    Price
                  </TableCell>
                </TableRow>
              </TableHead>
              {values && values.length > 0 ? (
                <TableBody>
                  {values?.map((data: any, index: any) => {
                    const availableQty = data.quantity - data?.soldOut;

                    let currentUTCDate: Date | null =
                      convertLocalDateToUTCIgnoringTimezone(new Date());
                    let startDateDiff = null;
                    let endDateDiff = null;

                    if (data?.saleStartDateUtc) {
                      startDateDiff = findDateDiff(
                        new Date(data?.saleStartDateUtc),
                        currentUTCDate
                      );
                    }

                    if (data?.saleEndDateUtc) {
                      endDateDiff = findDateDiff(
                        new Date(data?.saleEndDateUtc),
                        currentUTCDate
                      );
                    }

                    return (
                      <TableRow key={index}>
                        <TableCell
                          style={{
                            fontSize: "16px",
                            color: Color.color21,
                            flexDirection: "column",
                          }}
                        >
                          {data?.ticketType || ""}
                          <Typography
                            style={{ fontSize: "14px", color: "#8c8c8c" }}
                          >
                            {data?.description}
                          </Typography>
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "16px",
                            color: Color.color21,
                            textAlign: "center",
                          }}
                        >
                          <div>
                            <IconButton
                              sx={{ color: Color.red }}
                              onClick={() => handleDecrementQuantity(index)}
                              disabled={ticketQuantities[index] === 0}
                            >
                              -
                            </IconButton>
                            {ticketQuantities[index]}

                            <IconButton
                              sx={{ color: Color.green }}
                              disabled={
                                data?.saleStartDateUtc === !null ||
                                data?.saleEndDateUtc === !null ||
                                ticketQuantities[index] >= availableQty ||
                                // availableQty >= data?.quantity ||

                                0 <= endDateDiff?.dateDiff ||
                                0 >= startDateDiff?.dateDiff
                              }
                              onClick={() => handleIncrementQuantity(index)}
                            >
                              +
                            </IconButton>
                          </div>
                          {data.soldOut >= data?.quantity ? (
                            <span style={{ color: "red" }}>Sold out</span>
                          ) : (
                            <>
                              {ticketQuantities[index] >= availableQty ? (
                                <span style={{ color: "red" }}>
                                  Limit exceeded
                                </span>
                              ) : (
                                <>
                                  {0 >= startDateDiff?.dateDiff && (
                                    <span style={{ color: "Green" }}>
                                      Sale starts from{" "}
                                      {moment(data?.saleStartDate).format(
                                        "MMM Do YYYY, h:mm A"
                                      )}
                                    </span>
                                  )}
                                  {0 <= endDateDiff?.dateDiff && (
                                    <span style={{ color: "red" }}>
                                      {/* Sale end from{" "}
                                      {moment(data?.saleEndDate).format(
                                        "MMM Do YYYY, h:mm A"
                                      )} */}
                                      Sale ended
                                    </span>
                                  )}
                                </>
                              )}
                            </>
                          )}

                          {/* {ticketQuantities[index] >= newQti && (
                            <span style={{ color: "red" }}>All Slot Book</span>
                          )} */}
                        </TableCell>
                        <TableCell style={{ fontSize: "16px", color: "#666" }}>
                          $<NumberFormat total={data.price || 0} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  <TableRow>
                    <TableCell
                      style={{
                        fontSize: "18px",
                        color: "#333",
                        fontWeight: "bold",
                        width: "40%",
                      }}
                    >
                      Subtotal
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "18px",
                        color: "#333",
                        fontWeight: "bold",
                        textAlign: "center",
                        width: "40%",
                      }}
                    >
                      {ticketQuantities.reduce(
                        (total, quantity) => total + quantity,
                        0
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "18px",
                        color: "#333",
                        fontWeight: "bold",
                        width: "20%",
                      }}
                    >
                      $<NumberFormat total={totalTicketPrices || 0} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <div>
                  <Typography>
                    No data available. Please select events.
                  </Typography>
                </div>
              )}
              <ValidationError formErrors={error} />
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Grid>
  );
};
interface PriceTableProps {
  values?: any;
  newData?: any;
  error?: any;
}
